import buttonShapes from "@insite/mobius/Button/buttonShapes";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import hoverAnimations from "@insite/mobius/Button/hoverAnimations";
import {
    ButtonAnimation,
    ButtonShape,
    ButtonType,
    ButtonVariant,
    MobiusButtonAnimation,
    MobiusButtonShape,
    MobiusButtonType,
    MobiusButtonVariant,
} from "@toolkit/Framework/Types/Button";
import { css } from "styled-components";

export interface MobiusButtonThemeProps {
    type?: MobiusButtonType;
    shape?: MobiusButtonShape;
    animation?: MobiusButtonAnimation;
}

export interface ButtonThemeProps {
    type?: ButtonType;
    shape?: ButtonShape;
    animation?: ButtonAnimation;
}

export const buttonThemeStyles = (variant: ButtonVariant = "primary") => {
    const _variant = variant as MobiusButtonVariant;

    return css`
        ${({ theme }) => {
            const _buttonVariantProps = theme.button[_variant];

            if (_buttonVariantProps) {
                const _type = _buttonVariantProps.buttonType;
                const _shape = _buttonVariantProps.shape as MobiusButtonShape;
                const _animation = _buttonVariantProps.hoverAnimation;

                const _buttonTypeFunction = _type ? buttonTypes[_type] : null;
                const _buttonShapeFunction = _shape ? buttonShapes[_shape] : null;
                const _hoverAnimationFunction = _animation ? hoverAnimations[_animation] : null;

                const buttonProps = {
                    ..._buttonVariantProps,
                    _color: _buttonVariantProps.color,
                    _sizeVariant: _buttonVariantProps.sizeVariant,
                    _size: _buttonVariantProps.size,
                    _shape: _buttonVariantProps.shape,
                    hoverTextColor: _buttonVariantProps.hoverTextColor,
                    theme,
                };

                return css`
                    ${_buttonTypeFunction ? _buttonTypeFunction(buttonProps) : null}
                    ${_buttonShapeFunction ? _buttonShapeFunction(buttonProps) : null}
                    ${_hoverAnimationFunction ? _hoverAnimationFunction() : null}
                    ${_buttonVariantProps.css}
                `;
            }

            return null;
        }}
    `;
};
